<div class="card-box first">
	<div class="wg-container">
		<h4 class="wg-area-heading text-dark">{{TR "Gatewaystatus aktuell"}}</h4>
		<div class="wg-area-main wg-single">
			{{>WIDGET_PERCENT config=widgetConfig}}
		</div>
		<div class="wg-area-legend">
			<span class="tc-primary m-l-5"><i class="fa fa-square tc-primary"> </i> {{TR "Online"}}: <b>{{online}}</b></span>
			<span class="tc-grey m-l-5"><i class="fa fa-square tc-grey"> </i> {{TR "Offline"}}: <b>{{offline}}</b></span>
		</div>
	</div>
</div>
<div class="card-box second">
	<div class="wg-container">
	<h4 class="wg-area-heading text-dark">{{TR "Gateways mit Verbindungsabbruch"}}</h4>
		{{#each intervals}}
			<div class="ie-col-{{CALCULATE 1 '+' @index}} ie-row-2 wg-label">{{name}}</div>
			<div class="ie-col-{{CALCULATE 1 '+' @index}} ie-row-3">{{>WIDGET_PERCENT config=config}}</div>
			<div class="ie-col-{{CALCULATE 1 '+' @index}} ie-row-4 wg-value">{{count}}</div>
		{{/each}}
	</div>
</div>
</div>
<div class="card-box third">
	{{> WIDGET_BAR config=data_transfer}}
</div>

